var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "clinic-history-variable-chart",
    _vm._g(
      _vm._b(
        {
          attrs: {
            variableName: _vm.HEALTH_CONDITION_TODAY,
            chartData: _vm.chartData,
            additionalSeries: _vm.moodSeries ? [_vm.moodSeries] : [],
            coloringPoints: "",
            maxValue: 10,
            titleChart: _vm.titleChart,
            yAxisAdditional: _vm.yAxisAdditional ? this.yAxisAdditional : [],
            typeChart: "areaspline",
            hideMainSeriesByDefault: _vm.showMoodOnly,
            hideAdditionalSeriesByDefault: _vm.showVarOnly
          }
        },
        "clinic-history-variable-chart",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-649da4b4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-649da4b4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/TodayHealthConditionChart.vue
// module id = 4021
// module chunks = 39